import React, { useState, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { getGrowth10kData } from '../../Data/FundDetailsDataSource.js'
import {
  isDisplayNoMessageData,
  isPresented,
} from '../../Helpers/FundUtility.js'
import {
  ETF_FUND,
  ETF_INDEX_FUND,
  MUTUAL_FUND,
  MODEL_PORTFOLIOS,
  INTERVAL_FUND,
} from '../../Helpers/FundTypes.js'
import DataNotAvailable from '../../Helpers/DataNotAvailable.js'
import ErrorBoundary from './ErrorBoundary.jsx'
import PerformanceGrowthOf10k from './PerformanceGrowthOf10k.jsx'
import PerformanceTotalReturn from './PerformanceTotalReturn.jsx'
import PerformanceTotalReturnModelPortfolios from './PerformanceTotalReturnModelPortfolios.jsx'
import PerformanceCalendarYearReturns from './PerformanceCalendarYearReturns.jsx'
import PerformancePremiumDiscount from './PerformancePremiumDiscount.jsx'
import PerformanceDisclosures from './PerformanceDisclosures.jsx'
import './Performance.css'

export default function Performance({ fund, etfPremDiscMessage }) {
  const [growth10kData, setGrowth10kData] = useState(null)
  const fetchData = async () => {
    if (
      fund &&
      [MUTUAL_FUND, ETF_FUND, INTERVAL_FUND].includes(fund.fundGroup)
    ) {
      const _growth10kData = await getGrowth10kData(fund.cusip)
      setGrowth10kData(_growth10kData)
    }
  }

  useLayoutEffect(() => {
    fetchData()
  }, [])

  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="performance"
      id="performance"
    >
      <div className="u-sizeConstrained">
        <hr
          className="Rule Rule--thin Module-divider u-marginBottom12gu"
          role="presentation"
        />
        <div id="new-performance">
          {fund.fundGroup === ETF_FUND || fund.fundGroup === ETF_INDEX_FUND || fund.fundGroup === MODEL_PORTFOLIOS ? (
            <div data-performance-fund-type={fund.fundCategory || 'Retail'}>
              <h2
                className="u-marginBottom3gu"
                data-performance-fund-type={fund.fundCategory || 'Retail'}
              >
                Performance
              </h2>
            </div>
          ) : (
            <div data-performance-fund-type={fund.fundCategory || 'Retail'}>
              <h2
                className="u-marginBottom3gu"
                data-performance-fund-type={fund.fundCategory || 'Retail'}
              >
                Performance*
              </h2>
            </div>
          )}
        </div>

        {(fund.totalReturnPerformances &&
          fund.totalReturnPerformances.length > 0) ||
        fund.calendarYearReturns ||
        fund.premiumDiscountDetail ? (
          <div>
            {((fund.totalReturnPerformances &&
              fund.totalReturnPerformances.length > 0) ||
              fund.calendarYearReturns) && (
              <>
                {growth10kData &&
                  growth10kData.value &&
                  growth10kData.value.product &&
                  growth10kData.value.product.fundName &&
                  growth10kData.value.product.asOfDate && (
                    <PerformanceGrowthOf10k data={growth10kData} />
                  )}

                {fund.totalReturnPerformances.length > 0 &&
                fund.fundGroup === MODEL_PORTFOLIOS ? (
                  <PerformanceTotalReturnModelPortfolios
                    totalReturnPerformance={fund.totalReturnPerformances}
                  />
                ) : fund.totalReturnPerformances.length === 0 &&
                  fund.fundGroup === INTERVAL_FUND ? (
                  <div className="u-paddingBottom12gu">
                    <DataNotAvailable title={'Total Return Performance'} />
                  </div>
                ) : (
                  <PerformanceTotalReturn
                    fundGroup={fund.fundGroup}
                    totalReturnPerformance={fund.totalReturnPerformances}
                  />
                )}

                {fund.calendarYearReturnDetail &&
                  fund.calendarYearReturnDetail.calendarYearReturnLabels &&
                  isPresented(fund, 'calendarYearReturnDetail') && (
                    <PerformanceCalendarYearReturns
                      calendarYearReturns={fund.calendarYearReturnDetail}
                      fundGroup={fund.fundGroup}
                    />
                  )}
                {isDisplayNoMessageData(fund, 'calendarYearReturnDetail') && (
                  <div>
                    <DataNotAvailable title={'Calendar Year Returns'} />
                    <hr
                      className="Rule Rule--thin u-marginVert6gu Module-divider"
                      role="presentation"
                    />
                  </div>
                )}
              </>
            )}

            {fund.premiumDiscountDetail && (
              <ErrorBoundary
                message="Premium/Discount information is currently unavailable due to a technical issue. Please try again later."
                title="Premium/Discount"
              >
                <PerformancePremiumDiscount
                  etfPremDiscMessage={etfPremDiscMessage}
                  premiumDiscountDetail={fund.premiumDiscountDetail}
                />
              </ErrorBoundary>
            )}

            {fund.fundGroup && (
              <PerformanceDisclosures
                growthOf10K={growth10kData}
                fundGroup={fund.fundGroup}
                performanceDisclosure={fund.performanceDisclosure}
                fundName={fund.fundName}
              />
            )}
          </div>
        ) : (
          <div className="u-paddingBottom12gu">
            <DataNotAvailable />
          </div>
        )}
      </div>
    </section>
  )
}

Performance.propTypes = {
  etfPremDiscMessage: PropTypes.object,
  fund: PropTypes.object.isRequired,
}
